<!--
 * @Author: FengXiao
 * @Date: 2020-07-02 15:09:22
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-02 21:07:21
-->
<template>
  <div class="tab-activity-page content page-container">
    <div class="activitys-bl">
      <div class="activity-item" v-for="(item, index) in activitys" :key="item.id" @click="gotoDetail(item)">
        <div class="activity_cover">
          <img class="activity_cover-img" :src="item.cover" :alt="item.title" srcset="" />
        </div>
        <div class="activity_info">
          <div class="activity_title">{{ item.title }}</div>
          <div class="address-wrap">
            <span class="address">{{ item.city }}</span> / <span class="time">{{ item.date }}</span>
            <span class="ticket—status" v-if="+item.status === 0">正在售票</span>
          </div>
          <div class="activity-swiper-bl speaker" v-if="+item.status !== 2 && item.speakers && item.speakers.length">
            <swiper class="speaker-swiper" :options="swiperOptions(index, 'speaker')">
              <swiper-slide v-for="speaker in item.speakers" :key="speaker.id">
                <div class="speaker-item">
                  <div class="speaker_avatar">
                    <img :src="speaker.avatar" alt="" />
                  </div>
                  <div class="speaker_name">{{ speaker.speaker_name }}</div>
                  <div class="speaker_intro">
                    {{ speaker.intro }}
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="activity-swiper-bl" v-else-if="+item.type === 0 && item.speeches && item.speeches.length">
            <swiper class="speech-swiper" :options="swiperOptions(index)">
              <swiper-slide v-for="speech in item.speeches" :key="speech.id">
                <div class="speech-item" @click.stop="gotoSpeechDetail(speech)">
                  <div class="cover-wrap">
                    <img :src="speech.cover" :alt="speech.title" />
                  </div>
                  <div class="video_intro-wrap">
                    <div class="video_title">{{ speech.title }}</div>
                    <div class="speaker_name">{{ speech.speaker_name }}</div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="activity_intro" v-else-if="+item.type === 1" v-html="item.content"></div>
          <div class="swiper-btn-wrap" v-if="showSwiperBtns(item)">
            <div class="swiper-btn-prev swiper-btn" :class="`swiper-${index}`" @click.stop>
              <i class="iconfont iconarrow_left"></i>
            </div>
            <div class="swiper-btn-next swiper-btn" :class="`swiper-${index}`" @click.stop>
              <i class="iconfont iconarrow_right"></i>
            </div>
          </div>
        </div>
        <div class="activity_no">{{ item.periods }}期</div>
      </div>
    </div>
    <div class="load_more_btn" v-show="!isLoadedAll" @click="loadMore">加载更多</div>
  </div>
</template>

<script>
import requestApi from '@/service';

const SWIPER_SPEECH_PAGE_SIZE = 3;
const SWIPER_SPEAKER_PAGE_SIZE = 4;
export default {
  data() {
    return {
      activitys: [],
      pageNum: 1,
      pageSize: 5,
      total: 0,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.path !== '/activity/detail' || !vm.activitys.length) {
        vm.refreshData();
        vm.initScrollTop();
      }
    });
  },
  computed: {
    isLoadedAll() {
      return this.total / this.pageSize <= this.pageNum;
    },
  },
  methods: {
    refreshData() {
      this.pageNum = 1;
      this.activitys = [];
      this.getData();
    },
    swiperOptions(index, type) {
      const obj = {
        navigation: {
          prevEl: `.swiper-btn-prev.swiper-${index}`,
          nextEl: `.swiper-btn-next.swiper-${index}`,
        },
      };
      const pageSize = type === 'speaker' ? SWIPER_SPEAKER_PAGE_SIZE : SWIPER_SPEECH_PAGE_SIZE;
      Object.assign(obj, {
        slidesPerView: pageSize,
        slidesPerGroup: pageSize,
        spaceBetween: 20,
      });
      return obj;
    },
    getData() {
      requestApi('/v3/api/site/activity/extend/', {
        page: this.pageNum,
        page_size: this.pageSize,
      }).then(res => {
        if (this.pageNum === 1) {
          this.activitys = res.items;
          this.total = res.total;
        } else {
          this.activitys = this.activitys.concat(res.items);
        }
      });
    },
    loadMore() {
      if (!this.isLoadedAll) {
        this.pageNum += 1;
        this.getData();
      }
    },
    /**
     * @description: 打开现场详情
     */
    gotoDetail(data) {
      this.$router.push({
        path: '/activity/detail',
        query: {
          id: data.id,
        },
      });
    },
    /**
     * @description: 打开演讲详情
     */
    gotoSpeechDetail(data) {
      this.$router.push({
        path: '/speech/detail',
        query: {
          id: data.id,
        },
      });
    },
    showSwiperBtns(data) {
      // status type 逻辑互斥 且status优先级高于type 不可混为一同判断
      if (+data.status !== 2 && data.speakers && data.speakers.length) {
        if (data.speakers.length > SWIPER_SPEAKER_PAGE_SIZE) return true;
      } else if (+data.type === 0 && data.speeches && data.speeches.length) {
        if (data.speeches.length > SWIPER_SPEECH_PAGE_SIZE) return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.activitys-bl {
  .activity-item {
    width: 100%;
    height: 274px;
    background: $C1;
    display: flex;
    margin: 40px 0;
    cursor: pointer;
    position: relative;
    border: 1px solid $C11;
    .activity_cover {
      width: 490px;
    }
    .activity_info {
      flex: 1;
      position: relative;
      padding: 20px;
      max-width: calc(100% - 490px);
      box-sizing: border-box;
      .activity_title {
        font-family: HYXinRenWenSongW;
        font-size: 18px;
        line-height: 20px;
      }
      .address-wrap {
        font-size: 14px;
        color: $C9;
        height: 35px;
        line-height: 35px;
        width: auto;
        .address,
        .time {
          font-family: HYXinRenWenSongW;
        }
        .ticket—status {
          color: $C2;
          margin-left: 10px;
        }
      }
      .activity_intro {
        color: $C3;
        font-size: 14px;
        font-weight: 400;
        margin-top: 40px;
      }
      .swiper-btn-wrap {
        bottom: 0;
        top: unset;
      }
    }
    .activity_no {
      background: $C2;
      position: absolute;
      color: #ffffff;
      padding: 0px 10px;
      height: 35px;
      line-height: 35px;
      right: 0px;
      top: 20px;
    }
  }
  .activity-swiper-bl {
    position: relative;
    height: calc(100% - 35px - 20px);
    .speech-swiper {
      padding-bottom: 5px;
      margin-left: auto;
      margin-right: auto;
      .speech-item {
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
        transition: box-shadow 0.3s ease-out;
        &:hover {
          box-shadow: 3px 3px 6px $A6;
        }
        .cover-wrap {
          height: 110px;
        }
        .video_intro-wrap {
          padding: 5px 10px;
          .video_title {
            font-size: 14px;
            font-weight: 400;
            color: $C3;
            line-height: 30px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 100%;
          }
          .speaker_name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: $C13;
            font-size: 12px;
          }
        }
      }
    }
    &.speaker {
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
    }
    .speaker-swiper {
      margin: 0;
      width: 100%;
      .speaker-item {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background: $C10;
        width: 132px;
        height: 132px;
        position: relative;
        .speaker_avatar {
          width: 66px;
          height: 66px;
          min-height: 66px;
          border-radius: 50%;
          overflow: hidden;
        }
        .speaker_name {
          font-size: 14px;
          margin-top: 15px;
        }
        .speaker_intro {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          padding: 10px;
          font-size: 12px;
          background: $C10;
          transform: translateY(100%);
          transition: transform 0.3s ease;
        }
        &:hover {
          .speaker_intro {
            transform: translateY(0);
          }
        }
      }
    }
  }
}
</style>
